import { render, staticRenderFns } from "./editTemplate.vue?vue&type=template&id=3f4f730b&scoped=true"
import script from "./editTemplate.vue?vue&type=script&lang=js"
export * from "./editTemplate.vue?vue&type=script&lang=js"
import style0 from "./editTemplate.vue?vue&type=style&index=0&id=3f4f730b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f730b",
  null
  
)

export default component.exports